export function currency(value: string | number, digits: number = 0) {
  const formatter = new Intl.NumberFormat('en-au', {
    style: 'currency',
    currency: 'aud',
    minimumFractionDigits: digits,
  });
  const v: number = parseFloat(value.toString());
  return formatter.format(v);
}
